import { Button, styled } from '@mui/material';

export const LearnMoreButton = styled(Button)({
  color: 'red',
  border: '1px solid red',
  borderRadius: '25px',
  maxWidth: 180,
}) as typeof Button;
